import { render, staticRenderFns } from "./resetPwdForm.vue?vue&type=template&id=2c87d03c&scoped=true"
import script from "./resetPwdForm.vue?vue&type=script&lang=js"
export * from "./resetPwdForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c87d03c",
  null
  
)

export default component.exports